function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Player/02---1820",
  transform: "translate(-139.000000, -213.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Player/3"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(32.000000, 157.000000)"
}, React.createElement("path", {
  d: "M109.17682,56.5771972 L114.061701,59.8352358 C114.704953,60.2642615 114.878618,61.1335143 114.449592,61.7767663 C114.347139,61.9303772 114.215312,62.0622043 114.061701,62.1646572 L109.17682,65.4226957 C108.533568,65.8517214 107.664315,65.6780568 107.235289,65.0348048 C107.081871,64.8047802 107,64.5344781 107,64.257985 L107,57.741908 C107,56.9687093 107.626801,56.341908 108.4,56.341908 C108.676493,56.341908 108.946795,56.4237792 109.17682,56.5771972 Z M117,56 C117.552285,56 118,56.4477153 118,57 L118,65 C118,65.5522847 117.552285,66 117,66 C116.447715,66 116,65.5522847 116,65 L116,57 C116,56.4477153 116.447715,56 117,56 Z",
  id: "Combined-Shape",
  transform: "translate(112.500000, 61.000000) scale(-1, 1) translate(-112.500000, -61.000000) "
})))));

var SvgPrevious = function SvgPrevious(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "11px",
    height: "10px",
    viewBox: "0 0 11 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPrevious, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/previous.0075b596.svg";
export { ForwardRef as ReactComponent };